import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      title: 'Hello Kitty Game',
      description: 'The Hello Kitty Game is a cute, side-scrolling platformer inspired by Super Mario, where Hello Kitty runs and jumps through colorful levels, collects items, and avoids enemies along the way',
      technologies: ['JavaScript'],
      link: 'https://super-kitty-game.onrender.com/'
    },

    {
      title: 'AI Fitness Trainer',
      description: 'The app is an AI-powered fitness assistant that helps users achieve their health and fitness goals through personalized workouts, diet plans, and intelligent conversation',
      technologies: ['TypeScript', 'Next.js'],
      link: 'https://ai-fitness-trainer-oks7.onrender.com/'
    },

    {
      title: 'Chat App',
      description: 'Full-stack chat application with authentication and real-time messaging.',
      technologies: ['JavaScript', 'React', 'Node.js'],
      link: 'https://chat-app-i0io.onrender.com/login'
    },

    {
      title: 'Simon Game',
      description: 'The task is to repeat the color sequence shown by Simon. Each time you get it right, the sequence becomes longer and more challenging',
      technologies: ['JavaScript', 'HTML', 'CSS'],
      link: 'https://kristiana19.github.io/simon-game/'
    },

    {
      title: 'Drum Kit',
      description: 'A mini web application that allows you to play drums directly from the keyboard',
      technologies: ['JavaScript', 'HTML', 'CSS'],
      link: 'https://drum-kit-qxzt.onrender.com/'
    },

    {
      title: 'My Notes',
      description: 'A simple notes app for creating and organizing personal notes',
      technologies: ['JavaScript', 'HTML', 'CSS'],
      link: 'https://my-notes-gm5w.onrender.com/'
    }

  ];

  return (
    <section className="projects" id="projects">
      <div className="projects-container">
        <div className="section-header">
          <h2 className="section-title pink-bg">PROJECTS</h2>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-number">0{index + 1}</div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">{tech}</span>
                ))}
              </div>
              <a href={project.link} className="project-link">
                <span>View Project</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;